import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import HelpProvider from '@/help/HelpProvider';
import { mountVersionGuard } from '@version-guard';
import App from './App';
import './index.css';

// Antes de montar React, a proposito: la recuperacion de chunks tiene que
// estar escuchando desde el arranque, y el cartel de actualizacion vive fuera
// del arbol de React para sobrevivir a una app que no llego a montar.
// Politica 'banner': el admin no se recarga solo encima de un formulario a
// medio llenar; escala a recarga automatica recien cuando queda ocioso.
mountVersionGuard({
  portal: 'admin-portal',
  appName: 'el backoffice',
  policy: 'banner',
});

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('root element missing from index.html');
}

// TanStack Query: config default safe para admin (no-poll, stale 30s).
// M9.2+: ajustar por route (dashboard poll cada minuto, etc.).
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* Dentro del router a proposito: la ayuda cambia con la ruta (que
            recorrido ofrece, que capitulo del manual abre). */}
        <HelpProvider>
          <App />
        </HelpProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
